import ar from "./ar";
import en from "./en";

/*
 * careers translations live outside the shared dictionary so only this
 * feature's pages download them.
 */
export const careersTextByLocale = { ar, en };

export function getCareersText(locale) {
  return careersTextByLocale[locale] ?? careersTextByLocale.ar;
}
